import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
// import { Game } from '../../../Core'

import * as selectors from '../quizzes.selectors'
import * as actions from '../quizzes.actions'

import * as miningActions from '../../Mining/mining.actions'

const CAUSES = ['WRONG', 'BAD_TOPIC', 'OTHERS']

/**
 *  Pop up showed when you have finished the game
 */
class RefuseQuestion extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      cause: null,
      canSend: false,
      causeSelected: false,
    }
  }

  refuseQuestion(e) {
    const elements = this.form
    const { refuseQuestion, currentQuestion, clearFeedback } = this.props
    const { cause, missingParameter } = this.state

    e.preventDefault()
    e.stopPropagation()
    this.checkErrors()

    if (cause && missingParameter == '') {
      refuseQuestion({
        id: currentQuestion.id,
        cause: cause,
        explanation: elements['explanation'].value,
      })
      clearFeedback()
    }
  }

  checkErrors() {
    const elements = this.form
    if (elements['explanation'].value.length == 0) {
      this.setState({ missingParameter: 'explanation', canSend: false })
    } else {
      this.setState({ missingParameter: '', canSend: true })
    }
  }

  render() {
    const { intl, currentQuestion, changeMiningScreen, feedback } = this.props
    const { cause, missingParameter, canSend, causeSelected } = this.state

    if (!currentQuestion) {
      return null
    }

    return (
      <div className="mina--layer growIn-animation">
        <form
          onSubmit={(e) => this.refuseQuestion(e)}
          ref={(form) => (this.form = form)}
          className="mina--questions"
        >
          <div className="mina--question">
            <div>{currentQuestion.question}</div>
          </div>
          <div className="mina--buttons">
            {CAUSES.map((c) => (
              <div
                onClick={() => this.setState({ cause: c, causeSelected: true })}
                className={`mina--button__form ${c == cause ? 'selected' : ''}`}
                key={c}
              >
                <label>
                  <FormattedMessage id={`questions.${c.toLowerCase()}`} />
                </label>
                <input id={c} name="choices" value={c} type="radio"></input>
              </div>
            ))}
          </div>
          <textarea
            name="explanation"
            className={`mina--textarea ${missingParameter == 'explanation' ? 'failed' : ''}`}
            placeholder={intl.formatMessage({ id: 'questions.refuseExplanationPlaceHolder' })}
            onBlur={() => {
              this.checkErrors()
            }}
          />
          <div type="submit" className="mina--buttons">
            <button
              type="submit"
              className={`btn--orange ${canSend && causeSelected ? '' : 'disabled'}`}
            >
              <span className="icon-planet"></span>
              <span>{intl.formatMessage({ id: 'questions.submit' })}</span>
            </button>
            {!feedback.answerId ? (
              <button onClick={() => changeMiningScreen('answer_question')} className="btn--orange">
                <span className="icon-planet"></span>
                <span>{intl.formatMessage({ id: 'questions.back' })}</span>
              </button>
            ) : null}
          </div>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    refuseQuestion: bindActionCreators(actions.refuseQuestion, dispatch),
    changeMiningScreen: bindActionCreators(miningActions.changeMiningScreen, dispatch),
    clearFeedback: bindActionCreators(actions.clearFeedBack, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    feedback: selectors.getFeedBack(state),
    currentQuestion: selectors.getCurrentQuestion(state),
  }
}

RefuseQuestion.propTypes = {
  refuseQuestion: PropTypes.func,
  clearFeedback: PropTypes.func,
  changeMiningScreen: PropTypes.func,
  currentQuestion: PropTypes.object,
  feedback: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RefuseQuestion))
